var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShownForTesting)?_c('small',{staticClass:"pl-3 redirect-app align-content-center"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
            placement: 'right',
            title: _vm.title
        }),expression:"{\n            placement: 'right',\n            title: title\n        }",modifiers:{"hover":true}}],attrs:{"href":_vm.ciUrl,"target":"_blank"}},[_c('i',{staticClass:"fa-link fas icon"}),_vm._v(" APP ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }